import React from 'react';
import LinkAddEditTemplate from 'themes/modules/links/pages/LinkAddEditTemplate';
import { LinkAddEditViewStore } from '../stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new LinkAddEditViewStore(rootStore, componentProps), 'linkAddEditViewStore')
class LinkAddEdit extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <LinkAddEditTemplate {...this.props} />;
	}
}

export default LinkAddEdit;
